import toast, { Toaster } from 'react-hot-toast';
import { S3Client, DeleteObjectCommand, PutObjectCommand, GetObjectCommand } from "@aws-sdk/client-s3";
import {Config} from "../Config";
import Role from "./Role";
import {Buffer} from 'buffer';

export async function getAwsS3() {
    const roles = new Role();
    const response = await fetch(Config.url.API_URL +'/api/awsS3/view', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            id: 1
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export function s3Client(s3Data) {
    return new S3Client({
        region: s3Data.region,
        credentials: {
            apiVersion: s3Data.version,
            accessKeyId: s3Data.accessKeyId,
            secretAccessKey: s3Data.secretKey
        }
    });
}

export function getBase64(file) {
    return new Promise(resolve => {
        let baseURL = "";
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            baseURL = reader.result;
            resolve(baseURL);
        };
    });
}

export async function uploadFile(s3Data, uploadFile, newFilename) {
    try {
        // Make new FileReader
        let data = null;
        if(uploadFile && newFilename) {
            getBase64(uploadFile)
                .then(async base64String => {
                    const base64Data = new Buffer.from(base64String.split('base64,')[1], 'base64');
                    const type = base64String.split(';')[0].split(':')[1];

                    let params = {
                        ContentEncoding: 'base64',
                        ContentType: type,
                        Bucket: s3Data.bucket,
                        Key: s3Data.folderContentId + '/' + newFilename,
                        Body: base64Data
                    };

                    data = await s3Client(s3Data).send(new PutObjectCommand(params));
                })
                .catch(err => {
                    toast.error(err);
                });
        }
        else {
            toast.error('File not found');
        }
    } catch (err) {
        toast.error(err);
    }
}

export async function deleteFile(s3Data, fileName) {
    try {
        const data = s3Client(s3Data).send(new DeleteObjectCommand({
            Bucket: s3Data.bucket,
            Key: s3Data.folderContentId + '/' + fileName
        }));
        //console.log("Success. Object deleted.", data);
        //toast.success("Success. Object deleted.");
        return data; // For unit tests.
    } catch (err) {
        //console.log("Error", err);
        toast.error(err);
    }
}

export async function downloadFile(s3Data, fileName) {
    try {
        const response = await s3Client(s3Data).send(
            new GetObjectCommand({
                Bucket: s3Data.bucket,
                Key: s3Data.folderContentId + '/' + fileName,
            }),
        );
        let ByteArray = await response.Body.transformToByteArray();
        let ContentLength = await response.ContentLength;
        let ContentType = await response.ContentType;
        var blob = new Blob([ByteArray], {type: ContentType});
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
    } catch (caught) {
        toast.error(caught);
    }
}

export function viewFile(s3Data, fileName) {
    const AWS = require('aws-sdk');
    const s3 = new AWS.S3();
    AWS.config.update({
        accessKeyId: s3Data.accessKeyId,
        secretAccessKey: s3Data.secretKey,
        region: s3Data.region
    });

    const signedUrlExpireSeconds = 60 * 5; // your expiry time in seconds.
    const url = s3.getSignedUrl('getObject', {
        Bucket: s3Data.bucket,
        Key: s3Data.folderContentId + '/' + fileName,
        Expires: signedUrlExpireSeconds,
        ResponseContentDisposition :'attachment;filename=' + fileName
    });
    if(url) {
        return url;
    }
    else {
        toast.error('File not found');
    }
}

export async function viewBase64Image(s3Data, fileName) {
    try {
        const response = await s3Client(s3Data).send(
            new GetObjectCommand({
                Bucket: s3Data.bucket,
                Key: s3Data.folderContentId + '/' + fileName,
            }),
        );
        let fileBase64 = await response.Body.transformToString("base64");
        return 'data:image/jpg;base64,' + fileBase64;
    } catch (caught) {
        toast.error(caught);
    }
}